<template>
  <div
    class="profession-detail-skeleton"
    aria-busy="true"
    aria-live="polite">
    <section class="profession-detail-skeleton__hero hero-banner">
      <div class="profession-detail-skeleton__hero-image">
        <PrePeersSkeleton variant="block" />
      </div>
    </section>

    <section class="hero-section">
      <div class="container profession-detail-skeleton__hero-text">
        <PrePeersSkeleton
          variant="text"
          height="2.25rem"
          width="min(520px, 92%)" />
        <PrePeersSkeleton
          variant="text"
          width="100%" />
        <PrePeersSkeleton
          variant="text"
          width="88%" />
        <PrePeersSkeleton
          variant="text"
          width="72%" />
        <PrePeersSkeleton
          variant="text"
          width="120px"
          height="2px" />
      </div>
    </section>

    <section class="video-section">
      <div class="container profession-detail-skeleton__videos">
        <PrePeersSkeleton
          variant="text"
          height="1.5rem"
          width="min(480px, 90%)" />
        <div class="profession-detail-skeleton__video-grid">
          <PrePeersSkeleton
            v-for="index in 3"
            :key="index"
            variant="block"
            class="profession-detail-skeleton__video-frame" />
        </div>
      </div>
    </section>

    <section class="profession-detail-skeleton__metrics">
      <div class="container profession-detail-skeleton__metrics-grid">
        <PrePeersSkeleton
          v-for="index in 3"
          :key="index"
          variant="block"
          class="profession-detail-skeleton__metric-card" />
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import PrePeersSkeleton from '~/components/ui/PrePeersSkeleton.vue'
</script>

<style scoped>
/* Dimensions explicites : ne pas dépendre du chargement différé du design system. */
.profession-detail-skeleton__hero {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 280px;
  margin-bottom: 70px;
  overflow: visible;
  background-color: var(--bg-surface);
}

.profession-detail-skeleton__hero-image {
  position: absolute;
  top: 50%;
  left: 50%;
  width: clamp(300px, 70vw, 800px);
  height: 220px;
  max-height: 260px;
  transform: translate(-50%, -50%);
  border-radius: var(--radius-lg);
  overflow: hidden;
  z-index: 1;
}

.profession-detail-skeleton__hero-image :deep(.prepeers-skeleton) {
  width: 100%;
  height: 100%;
  border-radius: inherit;
}

.profession-detail-skeleton__hero-text {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.profession-detail-skeleton__videos {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

.profession-detail-skeleton__video-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-6);
  width: 100%;
  max-width: var(--container-xl);
  margin: 0 auto;
}

.profession-detail-skeleton__video-frame {
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: var(--radius-lg);
}

.profession-detail-skeleton__metrics {
  padding: var(--space-8) 0 var(--space-12);
}

.profession-detail-skeleton__metrics-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-6);
}

.profession-detail-skeleton__metric-card {
  min-height: 120px;
  border-radius: var(--radius-lg);
}

@media (max-width: 1024px) {
  .profession-detail-skeleton__video-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .profession-detail-skeleton__metrics-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .profession-detail-skeleton__video-grid,
  .profession-detail-skeleton__metrics-grid {
    grid-template-columns: 1fr;
  }
}
</style>
